import { isVideo, mergeClass } from "../../utils/common";
import { Player } from "video-react";

export default function NetworkMediaFile({
  file,
  className,
  loading,
  onClick,
}: {
  file?: {
    src?: string;
  };
  className?: string;
  loading?: "eager" | "lazy";
  onClick?: () => void;
}) {
  if (!file) return null;
  if (isVideo(file.src ?? "")) {
    return (
      <div
        className={mergeClass(
          "object-cover bg-black flex items-center w-full",
          className
        )}
      >
        <Player playsInline muted>
          <source src={file.src} />
        </Player>
      </div>
    );
  }
  return (
    <img
      src={file.src ?? "https://placehold.co/80x80"}
      alt={file.src}
      className={mergeClass(
        "object-cover",
        onClick ? "cursor-pointer" : "",
        className
      )}
      loading={loading}
      onClick={onClick}
    />
  );
}
